import { render, staticRenderFns } from "./DetalheEdital.vue?vue&type=template&id=5e169a1a&scoped=true"
import script from "./DetalheEdital.vue?vue&type=script&lang=js"
export * from "./DetalheEdital.vue?vue&type=script&lang=js"
import style0 from "./DetalheEdital.vue?vue&type=style&index=0&id=5e169a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e169a1a",
  null
  
)

export default component.exports